import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=6da33d4a"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da33d4a')) {
      api.createRecord('6da33d4a', component.options)
    } else {
      api.reload('6da33d4a', component.options)
    }
    module.hot.accept("./ReportsList.vue?vue&type=template&id=6da33d4a", function () {
      api.rerender('6da33d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/views/ReportsList.vue"
export default component.exports